export enum EApiErrorCode {
  VALIDATION_ERROR = 'ERR_VALIDATION_ERROR',
  ACCESS_DENIED = 'ERR_ACCESS_DENIED',
  NOT_FOUND = 'ERR_NOT_FOUND',
  CONFLICT = 'ERR_CONFLICT',
  INTERNAL_ERROR = 'ERR_INTERNAL_ERROR'
}

const ERROR_MESSAGES: Record<string, string> = {
  [EApiErrorCode.VALIDATION_ERROR]:
    'Проверьте корректность заполненных данных.',
  [EApiErrorCode.ACCESS_DENIED]: 'Недостаточно прав для выполнения операции.',
  [EApiErrorCode.NOT_FOUND]: 'Запрашиваемые данные не найдены.',
  [EApiErrorCode.CONFLICT]:
    'Операция не может быть выполнена из-за конфликта данных.',
  [EApiErrorCode.INTERNAL_ERROR]: 'Произошла внутренняя ошибка сервера.'
}

export const getErrorMessageByCode = (
  code?: EApiErrorCode
): string | undefined => {
  if (!code) return undefined
  return ERROR_MESSAGES[code]
}
